/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_CaptionInputs */

const cs_videos_caption = /** @type {(inputs: Videos_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek`)
};

const en_videos_caption = /** @type {(inputs: Videos_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption`)
};

/**
* | output |
* | --- |
* | "Caption" |
*
* @param {Videos_CaptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_caption = /** @type {((inputs?: Videos_CaptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_CaptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_caption(inputs)
	return cs_videos_caption(inputs)
});